// NGRX
import {createFeatureSelector, createSelector} from '@ngrx/store';
// Lodash
import {each} from 'lodash';
// CRUD
import {QueryResultsModel, HttpExtenstionsModel} from '../../_base/crud';
// State
import {LeaderLevelsState} from '../_reducers/leader-level.reducers';
import {LeaderLevelModel} from '../_models/leader-level.model';

export const selectLeaderLevelsState = createFeatureSelector<LeaderLevelsState>('leaderLevels');

export const selectLeaderLevelById = (leaderLevelId: number) => createSelector(
    selectLeaderLevelsState,
    leaderLevelsState => leaderLevelsState.entities[leaderLevelId]
);

export const selectLeaderLevelsPageLoading = createSelector(
    selectLeaderLevelsState,
    leaderLevelsState => leaderLevelsState.listLoading
);

export const selectLeaderLevelsActionLoading = createSelector(
    selectLeaderLevelsState,
    customersState => customersState.actionsloading
);

export const selectLeaderLevelsPageLastQuery = createSelector(
    selectLeaderLevelsState,
    leaderLevelsState => leaderLevelsState.lastQuery
);

export const selectLastCreatedLeaderLevelId = createSelector(
    selectLeaderLevelsState,
    leaderLevelsState => leaderLevelsState.lastCreatedLeaderLevelId
);

export const selectLeaderLevelsInitWaitingMessage = createSelector(
    selectLeaderLevelsState,
    leaderLevelsState => leaderLevelsState.showInitWaitingMessage
);

export const selectLeaderLevelsInStore = createSelector(
    selectLeaderLevelsState,
    leaderLevelsState => {
        const items: LeaderLevelModel[] = [];
        each(leaderLevelsState.entities, element => {
            items.push(element);
        });
        const httpExtension = new HttpExtenstionsModel();
        const result: LeaderLevelModel[] = httpExtension.sortArray(items, leaderLevelsState.lastQuery.sortField, leaderLevelsState.lastQuery.sortOrder);
        return new QueryResultsModel(result, leaderLevelsState.totalCount, '');
    }
);

export const selectHasLeaderLevelsInStore = createSelector(
    selectLeaderLevelsInStore,
    queryResult => {
        if (!queryResult.totalCount) {
            return false;
        }

        return true;
    }
);
